import React from 'react';



type Props  =  {
  className?: string;
}
export const EmptyCaseAlarmVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '100%' height = '100%'  viewBox = '0 0 88 88' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '2' d = 'M77 77H11.0001L11 11L61.6446 11L76.9999 26.8793V68' />
      <path stroke = 'currentColor' strokeWidth = '2' d = 'M43.7771 24V53.1667M43.7771 59.1667V64' />
    </svg>
  );
};
